import React, { useEffect, useState } from "react";
import { useQuery, useMutation } from "react-query";
import MaterialReactTable from "material-react-table";
import {
  Spinner,
  Toast,
  ToastBody,
  ToastHeader,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import useAxios from "../../sections/useAxios";
import { useParams } from "react-router-dom";

const SlotWiseMeetingsListing = () => {

  const { name } = useParams();
  const api = useAxios();
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const {
    data,
    isLoading: investorsLoading,
    isError,
    error,
    refetch,
  } = useQuery(
    ["investors-list"],
    async () => {
      const res = await api.get(`company/all-meeting-investors/${name}`);
      return res.data;
    },
    { cacheTime: 0 }
  );

  const slotWiseData = data?.investors ?? [];

  const columns = [
    { accessorKey: "id", header: "ID", size: 50 },
    {
      accessorKey: "name",
      header: "Investor Name",
    },
    { accessorKey: "email", header: "Email" },
    { accessorKey: "company", header: "Company" },
    // {
    //   accessorKey: "registration_count",
    //   header: "Registration Count",
    //   muiTableHeadCellProps: { align: "center" },
    //   muiTableBodyCellProps: { align: "center" },
    // },
    // {
    //   accessorKey: "registrations",
    //   header: "Registrations",
    //   muiTableHeadCellProps: { align: "center" },
    //   muiTableBodyCellProps: { align: "center" },
    //   Cell: ({ row }) => (
    //     <i
    //       className="fa-solid fa-clipboard-list fa-xl text-primary"
    //       style={{ cursor: "pointer" }}
    //       onClick={() => {
    //         setSelectedInvestor(row.original);
    //         setModalOpen(true);
    //       }}
    //     ></i>
    //   ),
    // },
    {
      accessorKey: "created_at",
      header: "Created At",
      Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
    },
  ];

  return (
    <div className="container mt-4">
      <h4 className="primary-color fw-bold">Registrations</h4>

      {investorsLoading && (
        <div className="d-flex justify-content-center align-items-center my-4">
          <Spinner color="primary" />
        </div>
      )}

      {showToast && (
        <div
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 1050,
            minWidth: "250px",
          }}
        >
          <Toast isOpen={showToast}>
            <ToastHeader icon="danger">Error</ToastHeader>
            <ToastBody>{toastMsg}</ToastBody>
          </Toast>
        </div>
      )}

      {!investorsLoading && !isError && (
        <MaterialReactTable
          columns={columns}
          data={slotWiseData}
          muiTablePaperProps={{
            elevation: 10,
          }}
        />
      )}

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg">
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
          Registrations for {selectedInvestor?.name}
        </ModalHeader>
        <ModalBody>
          {selectedInvestor?.registrations?.length > 0 ? (
            <Table bordered hover responsive>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Meeting</th>
                  <th>Company</th>
                  <th>Location</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                </tr>
              </thead>
              <tbody>
                {selectedInvestor.registrations.map((reg) => (
                  <tr key={reg.id}>
                    <td>{reg.id}</td>
                    <td>{reg.meeting}</td>
                    <td>{reg.company}</td>
                    <td>{reg.location}</td>
                    <td>{reg.start_time}</td>
                    <td>{reg.end_time}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>No registrations found for this investor.</p>
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default SlotWiseMeetingsListing